export default __webpack_public_path__ + "static/media/step4_poi_image1.b5522831.jpg";